import { safeGetItem, USER } from '../../lib/storage'

export const BELL_ROLES = ['customer', 'user', 'affiliate', 'affiliateGroupsAdmin']

export const storedRole = () => {
  try {
    return JSON.parse(safeGetItem(USER) || 'null')?.role || null
  } catch (error) {
    return null
  }
}

export const canSeeBell = (role) => BELL_ROLES.includes(role)
